import SalesGoals from "@/components/SalesGoals";
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { MessageSquare, Users, Inbox, Wifi } from "lucide-react";
import { useWhatsAppStatus } from "@/hooks/useWhatsAppStatus";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

function Stat({ icon: Icon, label, value, tone = "emerald" }) {
  const tones = {
    emerald: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20",
    amber:   "text-amber-400 bg-amber-500/10 border-amber-500/20",
    slate:   "text-slate-400 bg-slate-500/10 border-slate-500/20",
  };
  return (
    <Card className="bg-[#111827] border-slate-800 hover:border-slate-700 transition-colors p-5">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs font-mono uppercase tracking-wider text-slate-500 mb-1.5">{label}</div>
          <div className="text-3xl font-semibold tracking-tight">{value}</div>
        </div>
        <div className={`w-10 h-10 rounded-lg border grid place-items-center ${tones[tone]}`}>
          <Icon className="w-5 h-5" />
        </div>
      </div>
    </Card>
  );
}

export default function DashboardPage() {
  const { status } = useWhatsAppStatus();
  const [stats, setStats] = useState({ contacts: 0, feedbacks: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [c, f] = await Promise.all([api.get("/contacts"), api.get("/feedbacks")]);
        setStats({ contacts: c.data.length, feedbacks: f.data.length });
      } catch { /* ignore */ }
    })();
  }, []);

  return (
    <div className="space-y-8" data-testid="dashboard-root">
      <div>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">Painel de Vendas</h1>
        <p className="text-slate-400 mt-2 max-w-2xl">
          Painel de acompanhamento das vendas e atendimentos via WhatsApp. Conecte seu número, receba mensagens, responda com delay humanizado.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        <Stat icon={Wifi}          label="Sessão WhatsApp"    value={status}       tone={status === "connected" ? "emerald" : status === "qr_pending" ? "amber" : "slate"} />
        <Stat icon={Users}         label="Contatos"           value={stats.contacts}   tone="slate" />
        <Stat icon={Inbox}         label="Leads em Aberto"  value={stats.feedbacks}  tone="emerald" />
      </div>

      <SalesGoals />

      <Card className="bg-[#111827] border-slate-800 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h2 className="text-xl font-semibold flex items-center gap-2">
              <MessageSquare className="w-5 h-5 text-emerald-400" /> Comece por conectar
            </h2>
            <p className="text-slate-400 text-sm mt-1">
              Escaneie o QR code para vincular seu número WhatsApp ao Acompanhamento Vendas..
            </p>
          </div>
          <Link to="/whatsapp">
            <Button className="bg-emerald-500 hover:bg-emerald-600 text-white">Ir para Meu WhatsApp</Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}

